sap.ui.define(["sap/ui/core/library", 'sap/uxap/BlockBase'], function (coreLibrary, BlockBase) {
	"use strict";

	var ViewType = coreLibrary.mvc.ViewType;

	var Leaves = BlockBase.extend("com.reply.leaviosa.blocks.leaves.Leaves", {
		metadata: {
			views: {
				Collapsed: {
					viewName: "com.reply.leaviosa.blocks.leaves.Leaves",
					type: ViewType.XML
				},
				Expanded: {
					viewName: "com.reply.leaviosa.blocks.leaves.Leaves",
					type: ViewType.XML
				}
			}
		}
	});
    
	return Leaves;
});